// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #region Responsive Framework */
/* #endregion */
/* #region Content Items */
/* #endregion */
/* #region Color Palette */
/* #region Border Radius */
/* #endregion */
/* #region Typography */
/* #endregion */
/* #region Button */
/* #endregion */
/* #region Z-Index */
/* #endregion */
.overlay__P_3qY {
  position: fixed;
  top: 0;
  right: 0;
  width: 450px;
  height: 100vh;
  background-color: transparent;
  color: #e0e0e0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  font-family: monospace;
  border-left: 1px solid rgba(255, 255, 255, 0.06);
  opacity: 0.6;
  transition: width 0.2s ease, background-color 0.2s ease;
  pointer-events: none;
}

.overlay--focused__z993h,
.overlay--browser__SjVm5:hover {
  width: 675px;
  background-color: rgba(0, 0, 0, 0.88);
  border-left-color: #333;
  opacity: 1;
  pointer-events: auto;
}

.overlay--browser__SjVm5 {
  pointer-events: auto;
  background-color: rgba(0, 0, 0, 0.25);
  border-left-color: rgba(255, 255, 255, 0.12);
  transition: background-color 0.15s ease, border-left-color 0.15s ease;
}

.overlay__P_3qY.overlay--shift-passthrough__D1GBa {
  pointer-events: none;
  opacity: 0.2;
}

.list__ZMfsD {
  flex: 1;
  overflow-y: auto;
  padding: 12px 0;
}

.empty__r4Uvz {
  padding: 6px 14px;
  color: #555;
  font-size: 14px;
}

.entry__ZHmpR {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #1a1a1a;
  font-size: 14px;
  outline: none;
  cursor: pointer;
}

.entry--focused___3Ip0 {
  background-color: rgba(255, 255, 255, 0.08);
  border-left: 3px solid #4a9eff;
}

.entry-row__QKyer {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 8px 14px;
  flex-wrap: nowrap;
  overflow: hidden;
}

/* Unfocused: hide everything except cmd and badge */
.entry-id__kMadr,
.entry-time__jE3NF,
.entry-method__Pimgb,
.entry-duration__N7O_L {
  display: none;
}

.overlay--focused__z993h .entry-id__kMadr,
.overlay--focused__z993h .entry-time__jE3NF,
.overlay--focused__z993h .entry-method__Pimgb,
.overlay--focused__z993h .entry-duration__N7O_L,
.overlay--browser__SjVm5:hover .entry-id__kMadr,
.overlay--browser__SjVm5:hover .entry-time__jE3NF,
.overlay--browser__SjVm5:hover .entry-method__Pimgb,
.overlay--browser__SjVm5:hover .entry-duration__N7O_L {
  display: inline;
}

.entry-id__kMadr {
  color: #444;
  min-width: 30px;
  flex-shrink: 0;
}

.entry-time__jE3NF {
  color: #777;
  flex-shrink: 0;
}

.entry-cmd__Y5b0o {
  color: #c3e88d;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Dim cmd text when unfocused */
.overlay__P_3qY:not(.overlay--focused__z993h):not(.overlay--browser__SjVm5:hover) .entry-cmd__Y5b0o {
  color: #666;
  font-size: 11px;
}

.entry-method__Pimgb {
  color: #82aaff;
  font-weight: bold;
  flex-shrink: 0;
}

.entry-duration__N7O_L {
  color: #666;
  flex-shrink: 0;
}

.entry-error__gvVNe {
  color: #ff6b6b;
  font-size: 10px;
  padding: 0 14px 8px 44px;
  word-break: break-all;
  white-space: pre-wrap;
  margin: 0;
}

/* Hide badge when unfocused */
.badge__OEAaS {
  font-size: 10px;
  padding: 1px 5px;
  border-radius: 3px;
  font-weight: bold;
  text-transform: uppercase;
  flex-shrink: 0;
}

.overlay__P_3qY:not(.overlay--focused__z993h):not(.overlay--browser__SjVm5:hover) .badge--pending__QwM_q,
.overlay__P_3qY:not(.overlay--focused__z993h):not(.overlay--browser__SjVm5:hover) .badge--success__fXgON {
  display: none;
}

.badge--pending__QwM_q {
  background-color: #333;
  color: #999;
}

.badge--success__fXgON {
  background-color: #1a3a23;
  color: #69db7c;
}

.badge--error__nhCaH {
  background-color: #3a1010;
  color: #ff6b6b;
}

.entry-detail__RzLLX {
  padding: 4px 14px 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.entry-detail-label__nxlGv {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: #555;
  margin-top: 6px;
}

.entry-detail-pre__raMu_ {
  color: #ccc;
  font-size: 11px;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  background-color: rgba(255, 255, 255, 0.04);
  padding: 6px 8px;
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
}

.entry-detail-response-toggle__KIlu8 {
  font-size: 12px;
  color: #82aaff;
  padding: 6px 14px;
  cursor: pointer;
  border-left: 3px solid transparent;
}
.entry-detail-response-toggle__KIlu8.entry--focused___3Ip0 {
  background-color: rgba(255, 255, 255, 0.08);
  border-left-color: #4a9eff;
}`, "",{"version":3,"sources":["webpack://./src/scaffold/styles/variables.scss","webpack://./src/components/network-log-overlay/network-log-overlay.module.scss"],"names":[],"mappings":"AAOA,iCAAA;AAeA,eAAA;AAUA,0BAAA;AAqCA,eAAA;AAEA,0BAAA;AA+EA,0BAAA;AAMA,eAAA;AAEA,uBAAA;AA+EA,eAAA;AAEA,mBAAA;AAqBA,eAAA;AAEA,oBAAA;AAOA,eAAA;AC3QA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,YDHkB;ECIlB,aAAA;EACA,6BAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gDAAA;EACA,YAAA;EACA,uDAAA;EACA,oBAAA;AAYF;;AATA;;EAEE,YAAA;EACA,qCAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AAYF;;AARA;EACE,oBAAA;EACA,qCAAA;EACA,4CAAA;EACA,qEAAA;AAWF;;AALA;EACE,oBAAA;EACA,YAAA;AAQF;;AALA;EACE,OAAA;EACA,gBAAA;EACA,eAAA;AAQF;;AALA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AAQF;;AALA;EACE,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AAQF;;AALA;EACE,2CAAA;EACA,8BAAA;AAQF;;AALA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAQF;;AALA,oDAAA;AACA;;;;EAIE,aAAA;AAQF;;AALA;;;;;;;;EAQE,eAAA;AAQF;;AALA;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAQF;;AALA;EACE,WAAA;EACA,cAAA;AAQF;;AALA;EACE,cAAA;EACA,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAQF;;AALA,gCAAA;AACA;EACE,WAAA;EACA,eAAA;AAQF;;AALA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;AAQF;;AALA;EACE,WAAA;EACA,cAAA;AAQF;;AALA;EACE,cAAA;EACA,eAAA;EACA,wBAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;AAQF;;AALA,8BAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;AAQF;;AALA;;EAEE,aAAA;AAQF;;AALA;EACE,sBAAA;EACA,WAAA;AAQF;;AALA;EACE,yBAAA;EACA,cAAA;AAQF;;AALA;EACE,yBAAA;EACA,cAAA;AAQF;;AALA;EACE,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAQF;;AALA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAQF;;AALA;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,2CAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAQF;;AALA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;AAQF;AANE;EACE,2CAAA;EACA,0BAAA;AAQJ","sourcesContent":["@use 'sass:math';\n\n$transition-base: all 0.15s ease;\n$network-log-width: 450px;\n$header-height: 150px;\n$page-padding: 88px;\n\n/* #region Responsive Framework */\n\n$breakpoint-sm: 880px;\n$breakpoint-ms: 1000px;\n$breakpoint-md: 1260px;\n$breakpoint-lg: 1320px;\n$breakpoint-xl: 1920px;\n$breakpoint-xxl: 1921px;\n// max for portrait collection\n$breakpoint-maxP: 2875px;\n// max for landscape collection\n$breakpoint-maxL: 3421px;\n\n$min-ratio-base: 0.65;\n\n/* #endregion */\n\n$dialog-max-width: $breakpoint-xl;\n$dialog-max-height: 1080px;\n$dialog-min-width: $breakpoint-sm;\n$dialog-sidebar-width: 695px;\n$dialog-sidebar-min-width: 250px;\n\n$player-sheet-width: 695px;\n\n/* #region Content Items */\n\n$media-item-min-ratio: 0.85;\n$media-item-max-ratio: 1.75;\n\n$portrait-width: 257px;\n$portrait-height: 367px;\n$portrait-ratio: math.div($portrait-height, $portrait-width) * 100%;\n$portrait-width-min: calc($portrait-width * $media-item-min-ratio);\n$portrait-width-max: calc($portrait-width * $media-item-max-ratio);\n\n$landscape-width: 406px;\n$landscape-height: 229px;\n$landscape-ratio: math.div($landscape-height, $landscape-width) * 100%;\n$landscape-width-min: calc($landscape-width * $media-item-min-ratio);\n$landscape-width-max: calc($landscape-width * $media-item-max-ratio);\n\n$wide-landscape-width: 554px;\n$wide-landscape-height: 214px;\n$wide-landscape-ratio: math.div($wide-landscape-height, $wide-landscape-width) * 100%;\n$wide-landscape-width-min: calc($wide-landscape-width * $media-item-min-ratio);\n$wide-landscape-width-max: calc($wide-landscape-width * $media-item-max-ratio);\n\n$provider-box-width: 257px;\n$provider-box-height: 168px;\n$provider-box-ratio: math.div($provider-box-height, $provider-box-width) * 100%;\n$provider-box-width-min: calc($provider-box-width * $media-item-min-ratio);\n$provider-box-width-max: calc($provider-box-width * $media-item-max-ratio);\n\n$content-item-logo-width: 50px;\n$content-item-logo-height: 32px;\n$content-item-logo-ratio: math.div($content-item-logo-height, $content-item-logo-width) * 100%;\n$content-item-logo-width-min: calc($content-item-logo-width * $media-item-min-ratio);\n$content-item-logo-width-max: calc($content-item-logo-width * $media-item-max-ratio);\n\n$back-icon-button-position: 12px;\n\n/* #endregion */\n\n/* #region Color Palette */\n\n// Shades\n$color-shades-secondary-20: #1f2b37;\n\n// Tints\n$color-tint-60: #011224;\n$color-tint-primary-10: #1a2a3a;\n$color-tint-primary-60: #99a0a7;\n$color-tint-secondary-10: #3d4a58;\n\n// Palette: Background\n$color-background-default: #252525;\n$color-background-primary: #011224;\n$color-background-secondary: #273645;\n$color-background-tertiary: #414d5b;\n$color-background-level1: #303030;\n$color-background-level2: #ccc;\n\n// Palette: Divider & Common\n$color-divider: #9e9e9e;\n$color-white: #f2f2f2;\n$color-black: #000;\n\n// Palette: Error\n$color-error-main: #f44336;\n$color-error-dark: #d32f2f;\n$color-error-secondary: #ffdb38;\n$color-error-contrast-text: #f2f2f2;\n\n// Palette: Grey\n$color-grey-light: #9b9b9b;\n$color-grey-main: #505050;\n$color-grey-dark: #303030;\n\n// Palette: Primary\n$color-primary-main: #369993;\n$color-primary-dark: #00c9a2;\n$color-primary-contrast-text: #000;\n\n// Palette: Secondary\n$color-secondary-main: #755ffa;\n$color-secondary-dark: #8370f1;\n$color-secondary-contrast-text: #000;\n\n// Palette: Tertiary\n$color-tertiary-main: rgba(65, 77, 91, 0.8);\n\n// Palette: Royal Blue\n$color-royalblue-main: #002b6b;\n$color-royalblue-dark: #3f82cf;\n\n// Palette: Light Purple\n$color-lightpurple-main: #e3e1ff;\n$color-lightpurple-dark: #e3e1ff;\n\n// Palette: Red\n$color-red-main: #f8232d;\n$color-red-dark: #f84049;\n\n// Palette: Success\n$color-success-main: #00c9a2;\n$color-success-light: #369993;\n\n// Palette: Text\n$color-text-primary: #f2f2f2;\n$color-text-primary-hover: #f2f2f2;\n$color-text-secondary: #9b9b9b;\n$color-text-secondary-hover: #f2f2f2;\n$color-text-dark: #011224;\n$color-text-tint-60: #93999f;\n\n// space indicators\n$color-space-indicator-recorded: #2ed28b;\n$color-space-indicator-scheduled: #3f82cf;\n$color-space-indicator-free: #f5f5ed;\n\n//#endregion\n\n/* #region Border Radius */\n\n$border-radius-sm: 4px;\n$border-radius-md: 8px;\n$border-radius-lg: 12px;\n\n/* #endregion */\n\n/* #region Typography */\n\n// Typography: Font Family\n$font-family: 'Norlys', sans-serif;\n$font-family-headline: 'Norlys Headline', sans-serif;\n\n// Typography: Weight\n$font-weight-light: 300;\n$font-weight-regular: 400;\n$font-weight-medium: 500;\n$font-weight-bold: 700;\n\n// min values are used for fluid typography, to ensure that the font size does not go below\n// a certain threshold on smaller screens. typically, the min value is set to half of the\n// max value, but it can be adjusted as needed.\n\n$typography-min-ratio: 0.85;\n\n// Typography: h1-h6, body, caption, button\n$h1-font-family: $font-family-headline;\n$h1-font-size: 88px;\n$h1-font-size-min: calc($h1-font-size * $typography-min-ratio);\n$h1-line-height: 1.36em; // was: 120px\n$h1-font-weight: $font-weight-bold;\n\n$h2-font-family: $font-family-headline;\n$h2-font-size: 72px;\n$h2-font-size-min: calc($h2-font-size * $typography-min-ratio);\n$h2-line-height: 1.36em; // was: 98px\n$h2-font-weight: $font-weight-bold;\n\n$h3-font-family: $font-family-headline;\n$h3-font-size: 60px;\n$h3-font-size-min: calc($h3-font-size * $typography-min-ratio);\n$h3-line-height: 1.4em; // was: 84px\n$h3-font-weight: $font-weight-regular;\n\n$h4-font-family: $font-family;\n$h4-font-size: 50px;\n$h4-font-size-min: calc($h4-font-size * $typography-min-ratio);\n$h4-line-height: 1.4em; // was: 70px\n$h4-font-weight: $font-weight-bold;\n\n$h5-font-family: $font-family;\n$h5-font-size: 42px;\n$h5-font-size-min: calc($h5-font-size * $typography-min-ratio);\n$h5-line-height: 1.33em; // was: 56px\n$h5-font-weight: $font-weight-regular;\n\n$h6-font-family: $font-family;\n$h6-font-size: 35px;\n$h6-font-size-min: calc($h6-font-size * $typography-min-ratio);\n$h6-line-height: 1.4em; // was: 49px\n$h6-font-weight: $font-weight-bold;\n\n$body-font-family: $font-family;\n$body-font-size: 32px;\n$body-font-size-min: calc($body-font-size * $typography-min-ratio);\n$body-line-height: 1.38em; // was: 44px\n$body-font-weight: $font-weight-regular;\n\n$body-small-font-family: $font-family;\n$body-small-font-size: 28px;\n$body-small-font-size-min: calc($body-small-font-size * $typography-min-ratio);\n$body-small-line-height: 1.39em; // was: 39px\n$body-small-font-weight: $font-weight-regular;\n\n$caption-font-family: $font-family;\n$caption-font-size: 24px;\n$caption-font-size-min: calc($caption-font-size * $typography-min-ratio);\n$caption-line-height: 1.46em; // was: 35px\n$caption-font-weight: $font-weight-bold;\n\n$caption2-font-family: $font-family;\n$caption2-font-size: 22px;\n$caption2-font-size-min: calc($caption2-font-size * $typography-min-ratio);\n$caption2-line-height: 1.27em; // was: 28px\n$caption2-font-weight: $font-weight-regular;\n\n/* #endregion */\n\n/* #region Button */\n$button-font-size: 24px;\n$button-font-size-min: calc($button-font-size * $typography-min-ratio);\n$button-height: 72px;\n$button-height-min: calc($button-height * $min-ratio-base);\n$button-width: 406px;\n$button-width-min: calc($button-width * $min-ratio-base);\n\n$button-sm-font-size: 22px;\n$button-sm-font-size-min: calc($button-sm-font-size * $typography-min-ratio);\n$button-sm-height: 56px;\n$button-sm-height-min: calc($button-sm-height * $min-ratio-base);\n\n$button-header-font-size: 32px;\n$button-header-font-size-min: calc($button-header-font-size * $typography-min-ratio);\n$button-header-height: 80px;\n$button-header-height-min: calc($button-header-height * $min-ratio-base);\n\n$button-icon-size: 40px;\n$button-icon-size-min: calc($button-icon-size * $typography-min-ratio);\n\n/* #endregion */\n\n/* #region Z-Index */\n\n$zindex-player-controls: 1250;\n$zindex-dialog: 1300;\n$zindex-overlay: 1400;\n$zindex-tooltip: 1500;\n\n/* #endregion */\n","@use '/src/scaffold/styles/variables' as vars;  \n\n.overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: vars.$network-log-width;\n  height: 100vh;\n  background-color: transparent;\n  color: #e0e0e0;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  font-family: monospace;\n  border-left: 1px solid rgba(255, 255, 255, 0.06);\n  opacity: 0.6;\n  transition: width 0.2s ease, background-color 0.2s ease;\n  pointer-events: none;\n}\n\n.overlay--focused,\n.overlay--browser:hover {\n  width: vars.$network-log-width * 1.5;\n  background-color: rgba(0, 0, 0, 0.88);\n  border-left-color: #333;\n  opacity: 1;\n  pointer-events: auto;\n}\n\n// Browser mode has no D-pad focus to reveal the overlay, so it stays visible but dim until hovered.\n.overlay--browser {\n  pointer-events: auto;\n  background-color: rgba(0, 0, 0, 0.25);\n  border-left-color: rgba(255, 255, 255, 0.12);\n  transition: background-color 0.15s ease, border-left-color 0.15s ease;\n}\n\n// Holding Shift lets the user reach elements underneath the overlay without closing it.\n// Compound selector matches the specificity of `.overlay--browser:hover` so this reliably wins while hovered.\n// Border opacity is raised to full to visibly signal passthrough mode is active.\n.overlay.overlay--shift-passthrough {\n  pointer-events: none;\n  opacity: 0.2;\n}\n\n.list {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 0;\n}\n\n.empty {\n  padding: 6px 14px;\n  color: #555;\n  font-size: 14px;\n}\n\n.entry {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid #1a1a1a;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n}\n\n.entry--focused {\n  background-color: rgba(255, 255, 255, 0.08);\n  border-left: 3px solid #4a9eff;\n}\n\n.entry-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 8px 14px;\n  flex-wrap: nowrap;\n  overflow: hidden;\n}\n\n/* Unfocused: hide everything except cmd and badge */\n.entry-id,\n.entry-time,\n.entry-method,\n.entry-duration {\n  display: none;\n}\n\n.overlay--focused .entry-id,\n.overlay--focused .entry-time,\n.overlay--focused .entry-method,\n.overlay--focused .entry-duration,\n.overlay--browser:hover .entry-id,\n.overlay--browser:hover .entry-time,\n.overlay--browser:hover .entry-method,\n.overlay--browser:hover .entry-duration {\n  display: inline;\n}\n\n.entry-id {\n  color: #444;\n  min-width: 30px;\n  flex-shrink: 0;\n}\n\n.entry-time {\n  color: #777;\n  flex-shrink: 0;\n}\n\n.entry-cmd {\n  color: #c3e88d;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Dim cmd text when unfocused */\n.overlay:not(.overlay--focused):not(.overlay--browser:hover) .entry-cmd {\n  color: #666;\n  font-size: 11px;\n}\n\n.entry-method {\n  color: #82aaff;\n  font-weight: bold;\n  flex-shrink: 0;\n}\n\n.entry-duration {\n  color: #666;\n  flex-shrink: 0;\n}\n\n.entry-error {\n  color: #ff6b6b;\n  font-size: 10px;\n  padding: 0 14px 8px 44px;\n  word-break: break-all;\n  white-space: pre-wrap;\n  margin: 0;\n}\n\n/* Hide badge when unfocused */\n.badge {\n  font-size: 10px;\n  padding: 1px 5px;\n  border-radius: 3px;\n  font-weight: bold;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n\n.overlay:not(.overlay--focused):not(.overlay--browser:hover) .badge--pending,\n.overlay:not(.overlay--focused):not(.overlay--browser:hover) .badge--success {\n  display: none;\n}\n\n.badge--pending {\n  background-color: #333;\n  color: #999;\n}\n\n.badge--success {\n  background-color: #1a3a23;\n  color: #69db7c;\n}\n\n.badge--error {\n  background-color: #3a1010;\n  color: #ff6b6b;\n}\n\n.entry-detail {\n  padding: 4px 14px 10px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.entry-detail-label {\n  font-size: 10px;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: #555;\n  margin-top: 6px;\n}\n\n.entry-detail-pre {\n  color: #ccc;\n  font-size: 11px;\n  white-space: pre-wrap;\n  word-break: break-all;\n  margin: 0;\n  background-color: rgba(255, 255, 255, 0.04);\n  padding: 6px 8px;\n  border-radius: 4px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.entry-detail-response-toggle {\n  font-size: 12px;\n  color: #82aaff;\n  padding: 6px 14px;\n  cursor: pointer;\n  border-left: 3px solid transparent;\n\n  &.entry--focused {\n    background-color: rgba(255, 255, 255, 0.08);\n    border-left-color: #4a9eff;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay__P_3qY`,
	"overlay--focused": `overlay--focused__z993h`,
	"overlay--browser": `overlay--browser__SjVm5`,
	"overlay--shift-passthrough": `overlay--shift-passthrough__D1GBa`,
	"list": `list__ZMfsD`,
	"empty": `empty__r4Uvz`,
	"entry": `entry__ZHmpR`,
	"entry--focused": `entry--focused___3Ip0`,
	"entry-row": `entry-row__QKyer`,
	"entry-id": `entry-id__kMadr`,
	"entry-time": `entry-time__jE3NF`,
	"entry-method": `entry-method__Pimgb`,
	"entry-duration": `entry-duration__N7O_L`,
	"entry-cmd": `entry-cmd__Y5b0o`,
	"entry-error": `entry-error__gvVNe`,
	"badge": `badge__OEAaS`,
	"badge--pending": `badge--pending__QwM_q`,
	"badge--success": `badge--success__fXgON`,
	"badge--error": `badge--error__nhCaH`,
	"entry-detail": `entry-detail__RzLLX`,
	"entry-detail-label": `entry-detail-label__nxlGv`,
	"entry-detail-pre": `entry-detail-pre__raMu_`,
	"entry-detail-response-toggle": `entry-detail-response-toggle__KIlu8`
};
export default ___CSS_LOADER_EXPORT___;
